module.exports = __webpack_public_path__ + "static/images/c-home__section--light_pattern.29129e6a88c3e7d4828b03a57553cf38.png";